var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app-receipt" } },
    [
      _c(
        "div",
        { staticClass: "flex mb-6 gap-2" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v(" mdi-file-outline "),
          ]),
          _c("span", { staticClass: "text-xl font-medium text-primary" }, [
            _vm._v(_vm._s(_vm.$t("papers.header"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex flex-wrap" },
        [
          _c(
            "div",
            { staticClass: "mr-6 mb-6" },
            [_c("NewPaper", { attrs: { type: "card" } })],
            1
          ),
          _vm._l(_vm.paperGroupList.nodes, function (item) {
            return _c(
              "div",
              { key: `card-receipt-${item.id}`, staticClass: "mr-6 mb-6" },
              [
                _c("PaperCard", {
                  attrs: {
                    "item-id": item.id,
                    "inner-height": item.height,
                    "inner-width": item.width,
                    "paper-size": item.paperSize,
                    canvas: item.canvas || [],
                    margin: item.margin,
                  },
                  on: {
                    removed: function ($event) {
                      return _vm.refetch()
                    },
                  },
                }),
                _c(
                  "v-tooltip",
                  {
                    attrs: { disabled: item.name.length < 16, bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "div",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "mt-2 paper-name font-weight-medium secondary--text paper-name-caption text-overflow",
                                    },
                                    "div",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(" " + _vm._s(item.name) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      "v-card",
                      {
                        attrs: {
                          "max-width": "240",
                          color: "transparent",
                          flat: "",
                          dark: "",
                        },
                      },
                      [_vm._v(" " + _vm._s(item.name) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c("snt-pagination", {
        attrs: { "total-pages": _vm.paperGroupList.pagesCount },
        model: {
          value: _vm.page,
          callback: function ($$v) {
            _vm.page = $$v
          },
          expression: "page",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }